import nestAxios from './_nestAxios'

export const exportarExcel = data => nestAxios.get('/cuentas-contables/exportarExcel', { responseType: 'blob', params: data })

export const actualizarCuentaContable = (_id, data) => nestAxios.put(`/cuentas-contables/${_id}`, data)

export const actualizarCodigoEnlacexId = (_id, data) => nestAxios.put(`/cuentas-contables/${_id}/codigo-enlace`, data)

export const actualizarEnlaceCierreClase679xId = (_id, data) =>
  nestAxios.put(`/cuentas-contables/${_id}/enlace-cierre-clase679`, data)

export const asignarEnlacesDefecto = () => nestAxios.post('/cuentas-contables/asignar-enlaces-defecto')

export const copiarPlanAnoAnterior = () => nestAxios.post('/cuentas-contables/copiar-plan-ano-anterior')

export const asignarEnlacesCierreClase697Defecto = data =>
  nestAxios.post('/cuentas-contables/asignar-enlaces-cierre-clase697-defecto', data)

export const validarCuentasClase6789ConEnlaceCierre = () =>
  nestAxios.post('/cuentas-contables/cuentas-vs-enlaces-cierre')

export const eliminarCuentaContable = _id => nestAxios.delete(`/cuentas-contables/${_id}`)

export const getCuentasContables = busqueda =>
  nestAxios.get('/cuentas-contables', { params: { tipoConsulta: 'tree-view', busqueda: busqueda } })

export const getCuentasContablesAsAsignacionEnlace = params =>
  nestAxios.get('/cuentas-contables/obtener-cuentas-asignacion-enlace', { params })

export const obtenerCuentaClase79Clase80AsEnlaceCierre = () =>
  nestAxios.get('/cuentas-contables/obtener-cuenta-clase-79-clase-80')

export const obtenerCuentaClase59Ejercicios = () =>
  nestAxios.get('/cuentas-contables/obtener-cuenta-clase-59-ejercicio')

export const getCuentasContablesAsAsignacionEnlaceCierreClase679 = params =>
  nestAxios.get('/cuentas-contables/obtener-cuentas-asignacion-enlace-cierre-clase679', { params })

export const descargarPlantillaImportarCuentas = () =>
  nestAxios.get('/cuentas-contables/descargar/plantilla', {
    responseType: 'blob'
  })

export const getCuentaContablexTipoDocumentoxPrefijoCuenta = ({ tipoDocumento, prefijoCuenta }) =>
  nestAxios.get('/cuentas-contables', {
    params: { tipoConsulta: 'selectxTipoDocumento', tipoDocumento, prefijoCuenta }
  })

export const getCuentasContablesSelect = ({ busqueda, analitica }) =>
  nestAxios.get('/cuentas-contables', {
    params: {
      tipoConsulta: 'select2',
      analitica,
      busqueda
    }
  })

export const getCuentasContablesPresupuestoNuevo = (id) => nestAxios.get(`/cuentas-contables/presupuestos/${id}`)

export const getCuentasContablesParaCAsSelect = () =>
  nestAxios.get('/cuentas-contables', {
    params: {
      tipoConsulta: 'para-c'
    }
  })

export const getCuentasContablesConBusqueda = () =>
  nestAxios.get('/cuentas-contables', { params: { tipoConsulta: 'tree-view' } })

export const getCuentasContables_PorFiltros = ({ prefijo, moneda }) =>
  nestAxios.get('/cuentas-contables', {
    params: {
      tipoConsulta: 'prefijo-moneda',
      prefijo: prefijo,
      moneda: moneda
    }
  })

export const getCuentaContable = _id => nestAxios.get(`/cuentas-contables/${_id}`)

export const nuevaCuentaContable = data => nestAxios.post('/cuentas-contables', data)

export const importarCuentasContables = data => nestAxios.post('/cuentas-contables/importar', data)

export const reporteErroresImportacionCuentas = data =>
  nestAxios.post('/cuentas-contables/importar/reporte-errores', data, { responseType: 'blob' })
